import { List as ListOG, ListItem, ListItemText, SvgIconProps } from "@mui/material";
import React from 'react'

interface ListProps {
  className?: string,
  bullets: { label: string, icon: React.FC<SvgIconProps> }[],
}

// This list can be expanded in the future to include different types of lists
export default function List({ className, bullets }: ListProps) {
  return (
    <ListOG className={className}>
        {bullets.map((bullet, index) => (
          <ListItem>
            {bullet.icon ? <bullet.icon style={{ fontSize: 15 }} /> : null}
            <ListItemText key={index} primary={bullet.label} inset={true} />
          </ListItem>
        ))}
    </ListOG>
  )
}
